import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { clearFlowExecutionReports } from "redux/actions/flowDesigner/flowExecutionActionCreator";
import { clearNodesHighlight } from "layouts/Flow Designer/helpers/common";

const ExecutionReportPanelHeaderActions = () => {
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const [executionPanelHeaderActionsMenu, setExecutionPanelHeaderActionsMenu] = useState(null);

  const dispatch = useDispatch();

  const handleExecutionPanelHeaderActionsOpenMenu = (event) => {
    event.preventDefault();
    setExecutionPanelHeaderActionsMenu(event.currentTarget);
  };

  const handleExecutionPanelHeaderActionsMenuClose = () => {
    setExecutionPanelHeaderActionsMenu(null);
  };

  const clearExecutionReportPanelLogs = () => {
    dispatch(clearFlowExecutionReports(currentSavedFlow?.id));
    clearNodesHighlight();
    handleExecutionPanelHeaderActionsMenuClose();
  };

  const renderMenu = (state, close) => {
    return (
      <Menu
        anchorEl={state}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(state)}
        onClose={close}
        keepMounted
      >
        <MenuItem onClick={clearExecutionReportPanelLogs}>Clear Logs</MenuItem>
      </Menu>
    );
  };

  return (
    <>
      <Icon onClick={handleExecutionPanelHeaderActionsOpenMenu} sx={{ cursor: "pointer" }}>
        more_vert_icon
      </Icon>
      {renderMenu(executionPanelHeaderActionsMenu, handleExecutionPanelHeaderActionsMenuClose)}
    </>
  );
};

export default ExecutionReportPanelHeaderActions;
